import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { withListListItemForm, LinkListItemForm } from './LinkListItemForm'

class AddLinkListItemForm extends React.Component {
  handleAutoSyncOnBlur = e => {
    if (isEmpty(this.props.errors) && this.props.onSaveLink) {
      this.props.onSaveLink(this.props.values)
    }
  }

  componentDidMount() {
    this.props.validateForm()
  }

  render() {
    return (
      <LinkListItemForm
        {...this.props}
        handleAutoSyncOnBlur={this.handleAutoSyncOnBlur}
      />
    )
  }
}

export default compose(
  connect(
    ({ info: { language }}) => ({ language })
  ),
  withListListItemForm
)(AddLinkListItemForm)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/AddLinkListItemForm.js